<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">打电话</a></li>
                <li><a href="#">电话拨打记录</a></li>
            </ul>
        </div>    
        <div id="usual1" class="usual"> 
            <div class="formbody">
                <table class="tablelist">
    	            <thead>
                        <tr>
                        <th>主叫号码</th>
                        <th>被叫号码</th>
                        <th>开始时间</th>
                        <th>时长(分)</th>
                        <th>费用(元)</th>
                        <th>通道</th>
                        <th>状态</th>
                        </tr>
                    </thead>
                    <tbody>        
                        <tr v-for="(item,index) in dialdetailbillList" :class="{odd:index%2!=0}">
                        <td>{{item.srcnum}}</td>
                        <td>{{item.descnum}}</td>
                        <td>{{item.starttime}}</td>
                        <td>{{item.costtime}}</td>
                        <td>{{item.costfee}}</td>
                        <td>{{item.sendmethod}}</td>
                        <td><ol v-if="item.status==1">已接</ol><ol v-else-if="item.status==0" style="color:#17c200;">未接</ol></td>
                        </tr>         
                    </tbody>
                </table>
   
                <div class="pagin">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-sizes="[50]"
                        :page-size="50"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>
    
                <!-- 查询等待 -->
                <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                    top: 0; left: 0;display: block;" v-show="loadingShow"></div>
                <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                    -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                    <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                    <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
                </div>

                <div class="jian">&nbsp;</div>  
            </div> 
        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            dialdetailbillList:[],
            pageIndex:0,
            totalCount:0,
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            var that = this
            let data = {'pageIndex':pageIndex,'pageSize':50}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/dialphone/dialphonedetailbill.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.dialdetailbillList = res.data.dialdetailbillList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/dial/diallog.vue